<button
  type="button"
  class="legend-trigger"
  aria-label="Open color code legend"
  title="Color code legend"
  (click)="colorCodeModal.show()"
>
  <img
    alt=""
    src="assets/images/colorcode/icon-colorcodelegend-{{ theme$ | async }}.svg"
  />
</button>

<div
  bsModal
  #colorCodeModal="bs-modal"
  class="modal fade"
  tabindex="-1"
  role="dialog"
  aria-labelledby="color-code-legend-title"
>
  <div class="modal-dialog modal-dialog-centered color-code-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h6
          id="color-code-legend-title"
          class="modal-title text-primary font-weight-bold mb-0"
        >
          Colorcode legend
        </h6>
        <button
          type="button"
          class="close"
          aria-label="Close"
          (click)="colorCodeModal.hide()"
        >
          <span
            class="text-primary"
            aria-hidden="true"
          >
            &times;
          </span>
        </button>
      </div>
      <div class="modal-body color-code-body">
        <div class="legend-heading">
          <span>Color</span>
          <span>Status</span>
        </div>
        <div class="legend-row legend-row--striped">
          <span class="status-dot status-dot--active"></span>
          <span>Active</span>
        </div>
        <div class="legend-row">
          <span class="status-dot status-dot--pending"></span>
          <span>Pending, On hold, Tower Only, Being updated, Unknown</span>
        </div>
        <div class="legend-row legend-row--striped">
          <span class="status-dot status-dot--inactive"></span>
          <span>Inactive / Decommissioned</span>
        </div>
      </div>
    </div>
  </div>
</div>
